@if (!isLoading) {
<div>
  <div class="ot-row" style="margin-bottom: 0px;">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>Manifest</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="otsc-settings-manifest-save-btn" type="submit" class="ot-btn ot-btn--is-primary" (click)="save()"
          [disabled]="!settingsForm.dirty || settingsForm.invalid || isSaving || isUpdatingManifest">
          {{savingBtn}}
        </button>
        <button id="otsc-settings-manifest-reset-btn" type="reset" class="ot-btn ot-btn--is-secondary" (click)="reset()"
          [disabled]="isSaving || isUpdatingManifest" i18n>
          Restore defaults
        </button>
      </div>
    </div>
  </div>
  <div [style]="this.canEdit ? 'height: calc(100vh - 160px);' : 'height: 100vh;'">
    <ng-scrollbar #scrollbarRef>
      <div class="ot-message ot-message--is-info">
        <div class="ot-message__banner">
          <p class="ot-pl-1" id="otsc-settings-manifest-overview-msg">
            The system's current manifest was checked {{this.manifestStatus.lastCheckTimestamp | fromNow | lowercase}}
            and published on {{this.manifestStatus.publishedTimestamp | date:'LLL d, yyyy h:mm:ss aa'}}.
          </p>
        </div>
      </div>
      <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2">
        <div id="otsc-settings-manifest">
          <div class="row">
            <div class="ot-btn-group ot-pl-0">
              <button id="otsc-settings-manifest-checkForUpdates-btn" type="button" class="ot-btn ot-btn--is-secondary"
                (click)="checkForUpdates()" [disabled]="!isOnlinemode || isSaving || isUpdatingManifest" i18n>
                Check for updates
              </button>
              <button id="otsc-settings-manifest-uploadManifest-btn" type="button" class="ot-btn ot-btn--is-secondary"
                (click)="onClickDragDrop()" [disabled]="isSaving || isUpdatingManifest" i18n>
                Upload manifest
              </button>
              @if (this.canEdit) {
              <button id="otsc-settings-manifest-repairManifest-btn" type="button" class="ot-btn ot-btn--is-secondary"
                (click)="repair()" [disabled]="isSaving || isUpdatingManifest" i18n>
                Repair manifest data
              </button>
              }
            </div>
          </div>
          <form [formGroup]="settingsForm" name="otsc-settings-manifest-form">
            <fieldset [disabled]="!this.canEdit">
              <app-checkbox [identifier]="'autoUpdate'" formControlName="autoUpdateCtrl" [name]="'autoUpdate'"
                [toggle]="true" i18n-label [label]="'Enable Manifest URL update'" i18n-arialabel
                [arialabel]="'Enable/disable automatic manifest updates'" i18n-description
                [description]="'This option will automatically update the Manifest URL when a new manifest is found.'">
              </app-checkbox>
              <div class="ot-row ot-pb-1">
                <div class="ot-col ot-row__column ot-row__column--is-50">
                  <div class="ot-form-control"
                    [ngClass]="{'ot-form-control--is-invalid' : autoUpdateCtrl.value && baseURLCtrl.invalid}">
                    <label class="ot-form-control__label" for="baseURL" i18n>
                      Manifest URL
                    </label>
                    <div class="ot-form-control__input-group">
                      <input id="baseURL" formControlName="baseURLCtrl" placeholder="Enter manifest URL base"
                        type="text" maxlength="200" class="ot-input ot-input--is-expanded">
                      @if (baseURLCtrl.invalid) {
                      <span class="ot-form-control__error-icon"></span>
                      }
                    </div>
                    @if (baseURLCtrl.invalid && baseURLCtrl.errors.required) {
                    <p id="manifestURLRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                      Manifest URL is required.
                    </p>
                    }
                    @if (baseURLCtrl.invalid && baseURLCtrl.errors.pattern) {
                    <p id="invalidManifestURLMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                      Manifest URL must start with http:// or https://.
                    </p>
                    }
                    <p class="ot-form-control__info-text" i18n>
                      Manifest URL is used for updating the system manifest.
                    </p>
                  </div>
                  <div>
                    <a id="otsc-settings-manifest-url"
                      href="{{this.manifestStatus.manifestURL}}">{{this.manifestStatus.manifestURL}}</a>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </ng-scrollbar>
  </div>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n id="otsc-settings-manifest-loading">Loading...</div>
</div>
}